import { render, staticRenderFns } from "./SurveyMultipleChoiceInput.vue?vue&type=template&id=08a6c9eb&"
import script from "./SurveyMultipleChoiceInput.vue?vue&type=script&lang=js&"
export * from "./SurveyMultipleChoiceInput.vue?vue&type=script&lang=js&"
import style0 from "./SurveyMultipleChoiceInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports